import hrms75eLabels from 'assets/labels/hrms75e'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'
// import _ from 'lodash'

export const mocker = {
  labels () {
    return {
      labels: hrms75eLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        codempid: faker.random.number().toString().substr(0, 1),
        desc_codempid: faker.name.findName(),
        codcours: faker.random.number().toString().substr(0, 1),
        desc_codcours: faker.lorem.word(),
        desc_codpos: faker.lorem.word(),
        desc_codjob: faker.lorem.word(),
        numlvl: faker.random.number().toString().substr(0, 1),
        typemp: faker.lorem.word(),
        des_staappr: faker.lorem.word(),
        remarkap: faker.lorem.word(),
        staappr: 'P'
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detailCreate () {
    return {
      cours: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab1: {
        total: 0,
        rows: []
      },
      tab2: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab3: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab4: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      },
      tab5: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      }
    }
  },
  detail () {
    let mockDetailCours = {
      dteyear: moment().format('YYYY'),
      codempid: faker.random.number().toString().substr(0, 1),
      desc_codempid: faker.name.findName(),
      codeq: faker.random.number().toString().substr(0, 1)
    }
    let mockCoursRows = []
    const mockCoursTotal = 5
    for (var j = 1; j <= mockCoursTotal; j++) {
      mockCoursRows.push({
        numques: j,
        codcours: faker.random.number().toString().substr(0, 1),
        desc_codcours: faker.random.word(),
        des_staappr: faker.random.word(),
        staappr: 'P'
      })
    }
    let mockTab1Rows = []
    const mockTab1Total = 5
    for (var i = 1; i <= mockTab1Total; i++) {
      mockTab1Rows.push({
        codcours: faker.lorem.word(),
        desc_codcours: faker.lorem.word(),
        desc_codcate: faker.lorem.word(),
        desc_codtparg: faker.lorem.word(),
        qtytrmin: faker.random.number().toString().substr(0, 1)
      })
    }
    let mockDetailTab2 = {
      desc_codempid: faker.random.word(),
      desc_codcomp: faker.random.word(),
      desc_codpos: faker.random.word(),
      desc_codjob: faker.random.word()
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var b = 1; b <= mockTab2Total; b++) {
      mockTab2Rows.push({
        numques: b,
        codskill: faker.random.word(),
        desc_codskill: faker.random.word(),
        score: faker.random.number().toString().substr(0, 1),
        scoremp: faker.random.number().toString().substr(0, 1),
        v_average: faker.random.number().toString().substr(0, 1)
      })
    }
    let mockDetailTab3 = {
      codempid: faker.random.number().toString().substr(0, 1),
      desc_codcomp: faker.random.word(),
      desc_codpos: faker.random.word()
    }
    let mockTab3Rows = []
    const mockTab3Total = 5
    for (var a = 1; a <= mockTab3Total; a++) {
      mockTab3Rows.push({
        numques: a,
        codcours: faker.random.word(),
        desc_codcours: faker.random.word(),
        desc_codcate: faker.random.word(),
        desc_codtparg: faker.random.word(),
        qtytrmin: faker.random.number().toString().substr(0, 1),
        qtyposst: faker.random.number().toString().substr(0, 1),
        qtyposen: faker.random.number().toString().substr(0, 1)
      })
    }
    let mockDetailTab4 = {
      codempid: faker.random.number().toString().substr(0, 1),
      desc_codempid: faker.random.word(),
      desc_codcomp: faker.random.word(),
      desc_codpos: faker.random.word()
    }
    let mockTab4Rows = []
    const mockTab4Total = 5
    for (var k = 1; k <= mockTab4Total; k++) {
      mockTab4Rows.push({
        numques: k,
        desc_codcomp: faker.random.word(),
        desc_codpos: faker.random.word(),
        numseq: faker.random.number().toString().substr(0, 1)
      })
    }
    let mockDetailTab5 = {
      codempid: faker.random.number().toString().substr(0, 1),
      desc_codempid: faker.random.word(),
      desc_codcomp: faker.random.word(),
      desc_codpos: faker.random.word()
    }
    let mockTab5Rows = []
    const mockTab5Total = 5
    for (var l = 1; l <= mockTab5Total; l++) {
      mockTab5Rows.push({
        numques: l,
        codcours: faker.random.word(),
        desc_codcours: faker.random.word(),
        dteyear: moment().format('YYYY'),
        dtemonth: faker.random.word(),
        numclseq: faker.random.number().toString().substr(0, 1),
        dtetrst: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        amttrexp: faker.random.number().toString().substr(0, 1),
        qtytotscr: faker.random.number().toString().substr(0, 1),
        desc_flgtrevl: faker.random.word()
      })
    }

    return {
      cours: {
        detail: mockDetailCours,
        table: {
          total: mockCoursTotal,
          rows: mockCoursRows
        }
      },
      tab1: {
        total: mockTab1Total,
        rows: mockTab1Rows
      },
      tab2: {
        detail: mockDetailTab2,
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        }
      },
      tab3: {
        detail: mockDetailTab3,
        table: {
          total: mockTab3Total,
          rows: mockTab3Rows
        }
      },
      tab4: {
        detail: mockDetailTab4,
        table: {
          total: mockTab4Total,
          rows: mockTab4Rows
        }
      },
      tab5: {
        detail: mockDetailTab5,
        table: {
          total: mockTab5Total,
          rows: mockTab5Rows
        }
      }
    }
  },
  popupCours () {
    let mockPopupCours = {
      codcours: faker.random.number().toString().substr(0, 1),
      desc_codcours: faker.lorem.word(),
      desc_codcate: faker.lorem.word(),
      desc_codtparg: faker.lorem.word(),
      descrs1: faker.lorem.word(),
      amtbudg: faker.random.number().toString().substr(0, 1),
      syncond: faker.lorem.word()
    }

    return mockPopupCours
  },
  popupTab2 () {
    let mockPopupTab2Rows = []
    const mockPopupTab2Total = 5
    for (var b = 1; b <= mockPopupTab2Total; b++) {
      mockPopupTab2Rows.push({
        numques: b,
        codcours: faker.random.word(),
        desc_codcours: faker.random.word(),
        desc_codcate: faker.random.word(),
        desc_codtparg: faker.random.word(),
        qtytrmin: faker.random.number().toString().substr(0, 1)
      })
    }

    return {
      total: mockPopupTab2Total,
      rows: mockPopupTab2Rows
    }
  },
  popupTab4 () {
    let mockPopupTab4Rows = []
    const mockPopupTab4Total = 5
    for (var r = 1; r <= mockPopupTab4Total; r++) {
      mockPopupTab4Rows.push({
        numques: r,
        codcours: faker.random.word(),
        desc_codcours: faker.random.word(),
        desc_codcate: faker.random.word(),
        desc_codtparg: faker.random.word(),
        qtytrmin: faker.random.number().toString().substr(0, 1)
      })
    }

    return {
      total: mockPopupTab4Total,
      rows: mockPopupTab4Rows
    }
  },
  dropdowns () {
    let mockCodreqstDropdown = {}
    let mockKey = ''
    const totalCodreqstDropdown = 5 + Math.floor(Math.random() * 6)
    for (var i = 1; i < totalCodreqstDropdown; i++) {
      mockKey = i + ''
      mockCodreqstDropdown[mockKey] = faker.lorem.word()
    }
    return {
      codcours: {
        en: mockCodreqstDropdown,
        th: mockCodreqstDropdown
      }
    }
  },
  indexCancel () {
    return labels.mockPostMessage
  },
  save () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms75e/mocker.js